export const SET_AUTH = 'SET_AUTH';

export const SET_TIMER="SET_TIMER";

export const SET_SIMULATING_COUNT = "SET_SIMULATING_COUNT";